module.exports = __webpack_public_path__ + "img/bg_homepage.1356331f.jpg";